import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import queryBannerImage from "../../hooks/query-banner-image"
import useMinimalConfig from "../../hooks/use-minimal-config"
import useSiteMetadata from "../../hooks/use-site-metadata"
import replaceSlashes from "../../../utils/replace-slashes"
import { withCurrentCopyrightYear } from "../../../utils/copyright-year"
import { splitCopyrightText } from "../../../utils/footer-copyright"
import { FooterType } from "../../types"
import { isDesktopScreen } from "../../../utils/measure-screen-size"

type LayoutProps = {
  footer: FooterType
  [key: string]: any
}

const FooterLogo = ({ footer, ...props }: LayoutProps) => {
  const { footerNavigation: nav, basePath } = useMinimalConfig()
  const { siteImage, siteTitle, footerCopyrightText, footerPhoneNumber } = useSiteMetadata()
  const { copyright, disclaimer } = splitCopyrightText(footerCopyrightText ? footerCopyrightText.toString() : ``)
  const logoImage = queryBannerImage(footer?.logo || siteImage)
  const [height, setHeight] = useState(18)
  const logoImageAspectRatio = logoImage ? logoImage?.node?.gatsbyImageData.width / logoImage?.node?.gatsbyImageData.height : 1

  useEffect(() => {
    setHeight(isDesktopScreen() ? 36 : 18)
  })

  return (
    <footer className={`${footer.advanced?.class || `bg-footerBackground text-footerColor`} py-6 md:py-12 px-6 sm:px-6 xl:px-0`}>
      <div className="max-w-screen-lg mx-auto md:flex md:items-center md:justify-between ">
        <div className="md:order-1">
          {logoImage && (
            <div style={{ height: `${height}px`, width: `${height * logoImageAspectRatio}px` }}>
              <GatsbyImage image={getImage(logoImage?.node)!} style={{ height: `100%`, width: `100%` }} imgStyle={{ objectFit: "contain" }} alt={siteTitle} />
            </div>
          )}
        </div>

        <div className="mt-4 md:mt-0 flex md:justify-center space-x-6 md:order-2">
          {nav &&
            nav.map((item: any, itemIndex: any) => {
              if (item.type && item.type === "internal") {
                return (
                  <Link key={item.slug} className="text-footerColor underline text-xs md:text-base" to={replaceSlashes(`/${basePath}/${item.slug}`)}>
                    {item.title}
                  </Link>
                )
              } else {
                return (
                  <a href={`https://www.weshare.org${item.slug}`} target="_blank" className="text-footerColor underline text-xs md:text-base">{item.title}</a>
                )
              }
            })}
        </div>
      </div>

      {footerCopyrightText && (
        <div className="max-w-screen-lg mx-auto pt-10 text-center md:text-left text-footerColor text-sm">
          <div dangerouslySetInnerHTML={{ __html: withCurrentCopyrightYear(copyright) }}></div>
          {footerPhoneNumber && <p className="mt-4">{footerPhoneNumber}</p>}
          {disclaimer && <div className="mt-4" dangerouslySetInnerHTML={{ __html: disclaimer }}></div>}
        </div>
      )}
    </footer>
  )
}

export default FooterLogo